// The Project Report guide (16_ProjectReport.jsx · ModuleHelp, Max 01/11).
const en = {
  teamsT: 'Choose a report',
  teamsB: 'Four reports: Integrated Development Team, R&D Team, Project Owner and Ticket Station. The guide starts on the Integrated Development Team report.',
  statsT: 'Projects by status',
  statsB: 'The active projects counted by status, one bar each. The date and totals under the title say when the report was generated and how many projects and SKUs it covers.',
  filtersT: 'Narrow the report',
  filtersB: 'Pick assignees or statuses to see only those projects, and use Clear to go back to everything. Everything below follows the filters.',
  sectionT: 'The report tables',
  sectionB: 'Sections run from development through post-handoff and on-hold projects to the overview. Notes typed in a section are saved for the next reader.',
  exportT: 'Export to Excel',
  exportB: 'Exports the tables of the report you are looking at, with the filters applied, as an Excel file.',
};
const ko = {
  teamsT: '리포트 선택',
  teamsB: '통합 개발팀, R&D팀, 프로젝트 오너, 티켓 스테이션의 네 가지 리포트가 있습니다. 가이드는 통합 개발팀 리포트에서 시작합니다.',
  statsT: '상태별 프로젝트',
  statsB: '진행 중인 프로젝트를 상태별로 세어 막대 하나씩으로 보여 줍니다. 제목 아래 날짜와 합계는 리포트 생성 시점과 프로젝트·SKU 수를 알려 줍니다.',
  filtersT: '리포트 좁히기',
  filtersB: '담당자나 상태를 골라 해당 프로젝트만 보고, 초기화를 누르면 전체로 돌아갑니다. 아래 내용은 모두 필터를 따릅니다.',
  sectionT: '리포트 표',
  sectionB: '섹션은 개발, 이관 이후, 보류 프로젝트를 거쳐 개요까지 이어집니다. 섹션에 적은 메모는 저장되어 다음 사람이 볼 수 있습니다.',
  exportT: 'Excel로 내보내기',
  exportB: '지금 보고 있는 리포트의 표를 필터를 적용한 상태로 Excel 파일로 내보냅니다.',
};
const vi = {
  teamsT: 'Chọn báo cáo',
  teamsB: 'Có bốn báo cáo: Integrated Development Team, R&D Team, Project Owner và Ticket Station. Hướng dẫn bắt đầu từ báo cáo Integrated Development Team.',
  statsT: 'Dự án theo trạng thái',
  statsB: 'Các dự án đang hoạt động được đếm theo trạng thái, mỗi trạng thái một cột. Ngày và tổng số dưới tiêu đề cho biết báo cáo được tạo lúc nào và gồm bao nhiêu dự án, SKU.',
  filtersT: 'Thu hẹp báo cáo',
  filtersB: 'Chọn người phụ trách hoặc trạng thái để chỉ xem các dự án đó, và bấm xóa lọc để quay lại toàn bộ. Mọi nội dung bên dưới đều theo bộ lọc.',
  sectionT: 'Các bảng của báo cáo',
  sectionB: 'Các mục đi từ phát triển, sau bàn giao, dự án đang tạm dừng cho đến phần tổng quan. Ghi chú bạn nhập trong một mục được lưu lại cho người đọc sau.',
  exportT: 'Xuất ra Excel',
  exportB: 'Xuất các bảng của báo cáo đang xem, kèm bộ lọc đang áp dụng, thành file Excel.',
};
const zh = {
  teamsT: '选择报表',
  teamsB: '共有四份报表：Integrated Development Team、R&D Team、Project Owner 和 Ticket Station。本向导从 Integrated Development Team 报表开始。',
  statsT: '按状态统计项目',
  statsB: '进行中的项目按状态统计，每个状态一根柱子。标题下方的日期和合计说明报表的生成时间，以及涵盖的项目和 SKU 数量。',
  filtersT: '缩小报表范围',
  filtersB: '选择负责人或状态即可只看对应的项目，点击清除可回到全部。下方所有内容都会跟随筛选。',
  sectionT: '报表中的表格',
  sectionB: '各部分依次是开发、交接之后、暂停的项目，直到总览。在某个部分填写的备注会被保存，供下一位读者查看。',
  exportT: '导出到 Excel',
  exportB: '把当前查看的报表中的表格按已应用的筛选导出为 Excel 文件。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "teamsT": "Choisir un rapport",
  "teamsB": "Quatre rapports : Équipe de développement intégré, Équipe R&D, Responsable de projet et Ticket Station. Le guide commence sur le rapport Équipe de développement intégré.",
  "statsT": "Projets par statut",
  "statsB": "Les projets actifs comptés par statut, une barre chacun. La date et les totaux sous le titre indiquent quand le rapport a été généré et combien de projets et de SKU il couvre.",
  "filtersT": "Affiner le rapport",
  "filtersB": "Choisissez des assignés ou des statuts pour ne voir que ces projets, et utilisez Effacer pour tout revoir. Tout ce qui suit dépend des filtres.",
  "sectionT": "Les tableaux du rapport",
  "sectionB": "Les sections vont du développement aux projets en pause, en passant par l'après-transmission, jusqu'à la vue d'ensemble. Les notes saisies dans une section sont conservées pour le prochain lecteur.",
  "exportT": "Exporter vers Excel",
  "exportB": "Exporte sous forme de fichier Excel les tableaux du rapport affiché, avec les filtres appliqués."
};
const ja = {
  "teamsT": "レポートを選択",
  "teamsB": "4つのレポートがあります：「統合開発チーム」「R&Dチーム」「プロジェクトオーナー」「Ticket Station」。ガイドは「統合開発チーム」のレポートから始まります。",
  "statsT": "ステータス別のプロジェクト",
  "statsB": "進行中のプロジェクトをステータス別に、1本の棒で表示します。タイトル下の日付と合計は、レポートの生成日時と、対象のプロジェクト数・SKU 数です。",
  "filtersT": "レポートを絞り込む",
  "filtersB": "担当者またはステータスを選ぶと、該当するプロジェクトのみ表示されます。「クリア」ですべてに戻ります。以下はすべてフィルターに連動します。",
  "sectionT": "レポートの表",
  "sectionB": "セクションは、開発から、引き渡し後や保留中のプロジェクトを経て、概要まで続きます。各セクションに入力したメモは、次の閲覧者のために保存されます。",
  "exportT": "Excel にエクスポート",
  "exportB": "表示中のレポートの表を、フィルターを適用したまま Excel ファイルとしてエクスポートします。"
};

const dictionary = { ns: 'tourProjectReport', en, ko, vi, zh, fr, ja };
export default dictionary;
